/**
 * Class strings for buttons, fields and tables, so every page's controls look the
 * same. Nothing has a border: containers use the elevation shadows, and controls
 * the control shadow (src/index.css). Only thin dividers inside a container stay.
 *
 * On a phone (below `md`, UI-1) controls are 44px tall, and fields use 16px text so
 * iOS does not zoom in when one is focused.
 */

// Buttons with a surface rest on the control shadow, lift under the pointer (a larger
// shadow) and sink when pressed (a smaller one, 1px down); a disabled one stays put.
// Buttons without one (quiet, danger) only sink. The primary button wears whitelabels.com's
// CTA colours: its orange with black text, turning against the page under the pointer,
// near-black on the light theme and white on the dark one. No button has an outline.
export const btn = {
  primary:
    'inline-flex h-11 shrink-0 items-center justify-center gap-1.5 rounded-lg bg-brand px-4 text-sm text-black shadow-ctl transition hover:shadow-ctl-hover active:translate-y-px active:shadow-ctl-press hover:bg-cta-hover-bg hover:text-cta-hover-fg disabled:opacity-50 disabled:hover:bg-brand disabled:hover:text-black disabled:hover:shadow-ctl disabled:active:translate-y-0 disabled:active:shadow-ctl md:h-9',
  secondary:
    'inline-flex h-11 shrink-0 items-center justify-center gap-1.5 rounded-lg bg-control px-4 text-sm text-fg shadow-ctl transition hover:shadow-ctl-hover active:translate-y-px active:shadow-ctl-press hover:bg-surface-hover disabled:opacity-50 disabled:hover:shadow-ctl disabled:active:translate-y-0 disabled:active:shadow-ctl md:h-9',
  quiet:
    'inline-flex h-11 shrink-0 items-center justify-center gap-1.5 rounded-lg px-3 text-sm text-fg-muted transition hover:bg-surface-hover hover:text-fg active:translate-y-px disabled:opacity-50 disabled:active:translate-y-0 md:h-8',
  danger:
    'inline-flex h-11 shrink-0 items-center justify-center gap-1.5 rounded-lg px-4 text-sm text-danger transition hover:bg-danger/10 active:translate-y-px disabled:opacity-50 disabled:active:translate-y-0 md:h-9',
  link: 'text-sm text-brand underline-offset-2 hover:underline',
};

export const field = {
  label: 'mb-1 block text-xs text-fg-muted',
  input:
    'h-11 w-full min-w-0 rounded-lg bg-control px-3 text-base text-fg shadow-ctl placeholder:text-fg-faint focus:outline-none focus:ring-2 focus:ring-brand/50 md:h-9 md:text-sm',
  select: 'h-11 rounded-lg bg-control pl-3 pr-8 text-base text-fg shadow-ctl focus:outline-none focus:ring-2 focus:ring-brand/50 md:h-9 md:text-sm',
  textarea:
    'w-full min-w-0 rounded-lg bg-control px-3 py-2 text-base text-fg shadow-ctl placeholder:text-fg-faint focus:outline-none focus:ring-2 focus:ring-brand/50 md:text-sm',
  checkbox: 'h-5 w-5 rounded accent-brand md:h-4 md:w-4',
};

export const table = {
  wrap: 'overflow-hidden rounded-card bg-surface shadow-e1',
  table: 'w-full text-left text-sm',
  head: 'border-b border-line text-xs text-fg-muted',
  th: 'px-4 py-3 font-medium',
  row: 'border-b border-line last:border-0',
  rowLink: 'cursor-pointer border-b border-line transition-colors last:border-0 hover:bg-surface-hover',
  td: 'px-4 py-3',
};
